/* ===== TOP Leather theme.js ===== */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- Mobile nav ---------- */
  function bind(sel, evt, fn) { document.querySelectorAll(sel).forEach(function (el) { el.addEventListener(evt, fn); }); }
  var mnav = document.getElementById('MobileNav'), scrim = document.getElementById('NavScrim');
  function openNav() { if (mnav) mnav.classList.add('on'); if (scrim) scrim.classList.add('on'); }
  function closeNav() { if (mnav) mnav.classList.remove('on'); if (scrim) scrim.classList.remove('on'); }
  bind('[data-open-nav]', 'click', openNav);
  bind('[data-close-nav]', 'click', closeNav);
  if (scrim) scrim.addEventListener('click', closeNav);

  /* ---------- Theme toggle ---------- */
  bind('[data-theme-toggle]', 'click', function () {
    var r = document.documentElement;
    var cur = r.getAttribute('data-theme') || (matchMedia('(prefers-color-scheme:dark)').matches ? 'dark' : 'light');
    var next = cur === 'dark' ? 'light' : 'dark';
    r.setAttribute('data-theme', next);
    try { localStorage.setItem('tl-theme', next); } catch (e) {}
  });
  try { var saved = localStorage.getItem('tl-theme'); if (saved) document.documentElement.setAttribute('data-theme', saved); } catch (e) {}

  /* ---------- Slideshows ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('.slide'), dots = root.querySelectorAll('.dots button'), cur = 0, timer;
    if (slides.length < 2) return;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('on', x === cur); });
      dots.forEach(function (d, x) { d.classList.toggle('on', x === cur); });
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.i); restart(); }); });
    var auto = root.getAttribute('data-autoplay') === 'true', gap = (+root.getAttribute('data-interval') || 6) * 1000;
    function restart() { clearInterval(timer); if (auto && !reduce) timer = setInterval(function () { go(cur + 1); }, gap); }
    restart();
  });

  /* ---------- Collection tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('.tab'), panels = root.querySelectorAll('.panel');
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.tab'); if (!b) return;
      var i = b.dataset.i;
      tabs.forEach(function (x) { x.classList.toggle('on', x.dataset.i === i); });
      panels.forEach(function (x) { x.classList.toggle('on', x.dataset.i === i); });
    });
  });

  /* ---------- Variant colour swatches on cards ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.vsw'); if (!s) return;
    e.preventDefault();
    var card = s.closest('.card'); if (!card) return;
    var img = card.querySelector('.media-wrapper img:first-of-type'), src = s.getAttribute('data-img');
    if (img && src) {
      img.style.opacity = '0';
      setTimeout(function () { img.removeAttribute('srcset'); img.src = src; img.style.opacity = '1'; }, 120);
    }
    var href = s.getAttribute('data-url');
    if (href) {
      card.querySelectorAll('.meta h4 a, [data-main-image]').forEach(function (a) { a.href = href; });
    }
    var varId = s.getAttribute('data-variant-id');
    if (varId) {
      var idInput = card.querySelector('input[name="id"]');
      if (idInput) idInput.value = varId;
    }
    card.querySelectorAll('.vsw').forEach(function (x) { x.classList.toggle('on', x === s); });
  });

  /* ---------- PDP: variant option selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent || '[]');
    var priceEl = document.querySelector('[data-price]'),
        idInput = form.querySelector('[name="id"]'),
        addBtn = form.querySelector('[data-add]'),
        buyBtn = form.querySelector('[data-buy-now]'),
        mainMedia = document.querySelector('[data-main-media]');
    function selected() {
      var opts = [];
      form.querySelectorAll('[data-opt-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts[+group.getAttribute('data-opt-index')] = checked ? checked.value : null;
      });
      return opts;
    }
    function match() {
      var opts = selected();
      // Products with only Shopify's implicit "Default Title" have no visible
      // option controls, but still have one valid purchasable variant.
      if (!opts.length && variants.length === 1) return variants[0];
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function paint() {
      // highlight selected labels + update "Màu: X" text
      form.querySelectorAll('[data-opt-index]').forEach(function (group) {
        var lab = group.querySelector('.lab b');
        group.querySelectorAll('.sw, .size').forEach(function (l) {
          var input = l.querySelector('input');
          var on = input && input.checked;
          l.classList.toggle('on', !!on);
          if (on && lab) lab.textContent = input.value;
        });
      });
    }
    function update() {
      paint();
      var v = match();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Không có biến thể'; }
        if (buyBtn) buyBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var now = priceEl.querySelector('.now'), was = priceEl.querySelector('.was');
        if (now) now.textContent = v.price_html;
        if (v.compare_at_html) {
          if (!was) { was = document.createElement('span'); was.className = 'was'; priceEl.appendChild(was); }
          was.textContent = v.compare_at_html; was.hidden = false;
        } else if (was) { was.hidden = true; }
      }
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Thêm vào giỏ' : 'Hết hàng'; }
      if (buyBtn) buyBtn.disabled = !v.available;
      document.querySelectorAll('[data-mobile-price]').forEach(function (el) { el.textContent = v.price_html; });
      document.querySelectorAll('[data-mobile-buy]').forEach(function (el) { el.disabled = !v.available; });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({ variantId: v.id }, '', url.toString());
      document.dispatchEvent(new CustomEvent('tl:variant-change', { detail: v }));
    }
    form.addEventListener('change', function (e) { if (e.target.closest('[data-opt-index]')) update(); });
    update();
  });

  /* ---------- PDP media carousel + zoom lightbox ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-main-media]'), thumbs = [].slice.call(g.querySelectorAll('[data-thumb]')),
        templates = [].slice.call(g.querySelectorAll('[data-media-template]'));
    if (!main || !templates.length) return;
    var total = templates.length, cur = Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('on'); }));
    var modal = document.querySelector('[data-zoom-modal]'), zoom = modal && modal.querySelector('[data-zoom-media]'), count = modal && modal.querySelector('[data-zoom-count]'), lastFocus;
    function template(i) { return templates[i]; }
    function paint(target, i) {
      var tpl = template(i), node = tpl.content.cloneNode(true);
      target.classList.add('is-changing');
      setTimeout(function () { target.replaceChildren(node); target.classList.remove('is-changing'); }, 120);
      if (count) count.textContent = (i + 1) + ' / ' + total;
    }
    function show(i) {
      cur = (i + total) % total;
      paint(main, cur);
      thumbs.forEach(function (t) {
        var active = +t.getAttribute('data-media-index') === cur;
        t.classList.toggle('on', active); t.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && t.scrollIntoView) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      });
      if (zoom && modal.classList.contains('on')) paint(zoom, cur);
    }
    document.addEventListener('tl:variant-change', function (e) {
      var mediaId = e.detail && e.detail.featured_media_id;
      if (!mediaId) return;
      var i = templates.findIndex(function (tpl) {
        return String(tpl.getAttribute('data-media-id')) === String(mediaId);
      });
      if (i >= 0) show(i);
    });
    function closeZoom() { if (!modal) return; modal.classList.remove('on'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
    function openZoom() { if (!modal) return; lastFocus = document.activeElement; paint(zoom, cur); modal.classList.add('on'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var b = modal.querySelector('[data-zoom-close]'); if (b) b.focus(); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-media-index')); }); });
    show(cur);
    var trigger = g.querySelector('[data-zoom-open]'); if (trigger) trigger.addEventListener('click', openZoom);
    main.addEventListener('click', openZoom);
    var p = g.querySelector('[data-g-prev]'), n = g.querySelector('[data-g-next]');
    if (p) p.addEventListener('click', function () { show(cur - 1); });
    if (n) n.addEventListener('click', function () { show(cur + 1); });
    var touchStartX = 0, touchStartY = 0, stageEl = g.querySelector('.stage');
    if (stageEl) {
      stageEl.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });
      stageEl.addEventListener('touchend', function (e) {
        var diffX = touchStartX - e.changedTouches[0].screenX;
        var diffY = touchStartY - e.changedTouches[0].screenY;
        if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX > 0) show(cur + 1);
          else show(cur - 1);
        }
      }, { passive: true });
    }
    if (modal) {
      modal.querySelectorAll('[data-zoom-close]').forEach(function (el) { el.addEventListener('click', closeZoom); });
      var zp = modal.querySelector('[data-zoom-prev]'), zn = modal.querySelector('[data-zoom-next]');
      if (zp) zp.addEventListener('click', function () { show(cur - 1); });
      if (zn) zn.addEventListener('click', function () { show(cur + 1); });
      modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); if (e.key === 'ArrowLeft') show(cur - 1); if (e.key === 'ArrowRight') show(cur + 1); });
    }
  });

  /* ---------- Buy now: add current variant then go straight to checkout ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var buy = form.querySelector('[data-buy-now]'); if (!buy) return;
    function resetBuy() {
      buy.textContent = 'MUA NGAY';
      var id = form.querySelector('[name="id"]');
      var variantsData = form.querySelector('[data-variants]');
      if (!id || !variantsData) { buy.disabled = false; return; }
      try {
        var variants = JSON.parse(variantsData.textContent || '[]');
        var current = variants.find(function (v) { return String(v.id) === String(id.value); });
        buy.disabled = current ? !current.available : false;
      } catch (e) { buy.disabled = false; }
    }
    window.addEventListener('pageshow', resetBuy);
    buy.addEventListener('click', function () {
      var id = form.querySelector('[name="id"]'), qty = form.querySelector('[data-qty]');
      var error = form.querySelector('[data-buy-error]');
      var checkoutUrl = form.getAttribute('data-checkout-url') || '/checkout';
      if (!id || buy.disabled) return;
      if (error) { error.hidden = true; error.textContent = ''; }
      buy.disabled = true; buy.textContent = 'ĐANG XỬ LÝ…';

      // Shopify cart permalink maps variant + quantity directly into Shopify Checkout.
      // It avoids Ajax/rate-limit parsing and stays on Shopify's native checkout flow.
      var quantity = qty ? (parseInt(qty.value, 10) || 1) : 1;
      var root = checkoutUrl.replace(/checkout\/?$/, '');
      if (!root.endsWith('/')) root += '/';
      window.location.assign(root + 'cart/' + encodeURIComponent(id.value) + ':' + quantity + '?checkout');
    });
  });

  document.querySelectorAll('[data-mobile-buy]').forEach(function (button) {
    button.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      var buy = form && form.querySelector('[data-buy-now]');
      if (buy && !buy.disabled) buy.click();
    });
  });

  /* ---------- Mobile sticky buy bar scroll observer ---------- */
  var mobileBar = document.querySelector('[data-mobile-buy-bar]');
  var mainBuyBtn = document.querySelector('[data-buy-now], [data-add]');
  if (mobileBar && mainBuyBtn) {
    var checkMobileBar = function () {
      var rect = mainBuyBtn.getBoundingClientRect();
      mobileBar.classList.toggle('on', rect.bottom < 0);
    };
    window.addEventListener('scroll', checkMobileBar, { passive: true });
    window.addEventListener('resize', checkMobileBar, { passive: true });
    checkMobileBar();
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-qm]'), p = e.target.closest('[data-qp]');
    if (!m && !p) return;
    var box = (m || p).closest('.qty'), inp = box && box.querySelector('[data-qty]');
    if (!inp) return;
    inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (p ? 1 : -1));
  });

  /* ---------- PDP accordion ---------- */
  document.querySelectorAll('[data-acc] h3').forEach(function (h) {
    h.addEventListener('click', function () { h.parentElement.classList.toggle('open'); });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add]'), label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Đang thêm…'; }
    var qtyEl = form.querySelector('[data-qty]'), qv = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: qv }) })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (window.TLCart) { window.TLCart.render(cart); window.TLCart.open(); }
        else { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = false; }); }
        if (btn) { btn.disabled = false; btn.textContent = label; }
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- Cart drawer (preview trước checkout) ---------- */
  window.TLCart = (function () {
    var root = document.querySelector('[data-cart-drawer]'), ov = document.querySelector('[data-cd-overlay]');
    if (!root || !ov) return null;
    var itemsEl = root.querySelector('[data-cd-items]'),
        emptyEl = root.querySelector('[data-cd-empty]'),
        footEl = root.querySelector('[data-cd-foot]'),
        subEl = root.querySelector('[data-cd-subtotal]'),
        termsEl = root.querySelector('[data-cd-terms]'),
        checkoutBtn = root.querySelector('[data-cd-checkout]'),
        noteWrap = root.querySelector('[data-cd-note-wrap]'),
        noteEl = root.querySelector('[data-cd-note]'),
        upsellWrap = root.querySelector('[data-cd-upsell]'),
        upsellList = root.querySelector('[data-cd-upsell-list]'),
        upsellLoaded = false;

    function money(cents) {
      return Math.round(cents / 100).toLocaleString('vi-VN') + '₫';
    }
    function esc(s) { return String(s || '').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

    function open() {
      root.classList.add('on'); root.setAttribute('aria-hidden', 'false');
      ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('on'); });
      document.body.style.overflow = 'hidden';
    }
    function close() {
      root.classList.remove('on'); root.setAttribute('aria-hidden', 'true');
      ov.classList.remove('on'); setTimeout(function () { ov.hidden = true; }, 300);
      document.body.style.overflow = '';
    }

    function render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
      });
      itemsEl.innerHTML = cart.items.map(function (it, i) {
        var line = i + 1;
        var imgSrc = it.image ? it.image + (it.image.indexOf('?') >= 0 ? '&' : '?') + 'width=160' : '';
        var img = imgSrc ? '<img src="' + imgSrc + '" alt="' + esc(it.product_title) + '" width="80" height="80">' : '';
        var variant = (it.variant_title && it.variant_title.indexOf('Default') < 0) ? '<small>' + esc(it.variant_title) + '</small>' : '';
        var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s> ' : '';
        return '<div class="cd-item">' +
          '<a href="' + it.url + '" class="cd-img">' + img + '</a>' +
          '<div class="cd-info">' +
            '<a href="' + it.url + '" class="cd-title">' + esc(it.product_title) + '</a>' + variant +
            '<div class="cd-price">' + was + '<b>' + money(it.final_line_price) + '</b></div>' +
            '<div class="cd-qty">' +
              '<button type="button" data-cd-minus data-line="' + line + '" aria-label="Giảm">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-cd-plus data-line="' + line + '" aria-label="Tăng">+</button>' +
              '<button type="button" class="cd-del" data-cd-remove data-line="' + line + '" aria-label="Xoá">' +
                '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>' +
              '</button>' +
            '</div>' +
          '</div></div>';
      }).join('');
      subEl.textContent = money(cart.total_price);
      var has = cart.item_count > 0;
      emptyEl.hidden = has; footEl.hidden = !has;
      if (has && !upsellLoaded) loadUpsell(cart.items[0].product_id);
    }

    function refresh() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
    }
    function change(line, qty) {
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render);
    }

    function loadUpsell(pid) {
      upsellLoaded = true;
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=6')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var prods = (d && d.products) || [];
          if (!prods.length) return;
          upsellList.innerHTML = prods.map(function (p) {
            var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="' + esc(p.title) + '">' : '';
            return '<a class="cd-up" href="' + p.url + '">' + img +
              '<span><span class="t">' + esc(p.title) + '</span><span class="p">' + money(p.price) + '</span></span></a>';
          }).join('');
          upsellWrap.hidden = false;
        }).catch(function () {});
    }

    /* events */
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cd-open]');
      if (openBtn) { e.preventDefault(); refresh().then(open); return; }
      if (e.target.closest('[data-cd-close]')) { close(); return; }
      var minus = e.target.closest('[data-cd-minus]'), plus = e.target.closest('[data-cd-plus]'), rm = e.target.closest('[data-cd-remove]');
      if (minus || plus || rm) {
        var line = +((minus || plus || rm).getAttribute('data-line'));
        if (rm) { change(line, 0); return; }
        var span = (minus || plus).parentElement.querySelector('span');
        var q = parseInt(span.textContent, 10) || 1;
        change(line, Math.max(0, q + (plus ? 1 : -1)));
      }
    });
    ov.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('on')) close(); });

    if (termsEl && checkoutBtn) {
      termsEl.addEventListener('change', function () { checkoutBtn.disabled = !termsEl.checked; });
      checkoutBtn.addEventListener('click', function () { if (!checkoutBtn.disabled) window.location.href = '/checkout'; });
    }
    var noteToggle = root.querySelector('[data-cd-note-toggle]');
    if (noteToggle && noteWrap) {
      noteToggle.addEventListener('click', function () { noteWrap.hidden = !noteWrap.hidden; if (!noteWrap.hidden) noteEl.focus(); });
    }
    if (noteEl) {
      noteEl.addEventListener('change', function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: noteEl.value }) });
      });
    }

    return { open: open, close: close, render: render, refresh: refresh };
  })();
})();
